"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryDraw = void 0;
const HistoryDrawList_1 = require("./HistoryDrawList");
class HistoryDraw {
    constructor(data) {
        this.id = data.id;
        this.promotionId = data.promotionId;
        this.name = data.name;
        this.draw = data.draw;
        this.start = data.start;
        this.end = data.end;
        this.winnerAnnouncement = data.winnerAnnouncement;
        this.totalPrizeAmount = data.totalPrizeAmount;
        this.hasSuperBonus = data.hasSuperBonus;
        this.hasActiveDraws = data.hasActiveDraws;
        this.drawDateConverted = null;
        this.startDateConverted = null;
        this.endDateConverted = null;
        this.winnerAnnouncementDateConverted = null;
    }
}
exports.HistoryDraw = HistoryDraw;
HistoryDraw.JsonToDraws = (data) => {
    const drawsHistoryList = new HistoryDrawList_1.HistoryDrawList();
    data.forEach(draw => {
        if (!drawsHistoryList.map(x => x.id).includes(draw.id)) {
            drawsHistoryList.push(HistoryDraw.JsonToDraw(draw));
        }
    });
    return drawsHistoryList.getDrawDateConverted();
};
HistoryDraw.JsonToDraw = (data) => new HistoryDraw(data);
//# sourceMappingURL=HistoryDraw.js.map